import { Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import DeleteIcon from '../../../../Components/Icons/Delete';
import EditIcon from '../../../../Components/Icons/Edit';
import { NuDate, NuInput, NuInputWithError, NuTextArea } from '../../../../Components/Utils/Input';
import DropDownAddMetaData, { DropDownAddUnitWithError } from '../../../../Components/Utils/selectAddMetaData';
import FormikSelectTwo, { SelectProductWithError } from '../../../../Components/Utils/Select';
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import CloseIcon from '../../../../Components/Icons/Close';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseProductDropDownNew from '../../../../Components/Hooks/useProductSearch';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import { useLocation, useParams } from 'react-router-dom';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import { useToast } from '../../../../Components/Others/ToastServices';
import * as yup from 'yup';
import Video from '../../../../Components/Icons/Video';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
const filetype = [
    "docx",
    "doc",
    "xlsx",
    "xls",
    "pdf",
    "txt",
    "pptx",
    "mp4",
    "mov",
    "wmv",
    "avi",
    "flv",
    "mkv",
  ];

function EditInvoiceOutgoing() {
       const {value:Tax ,getData:refTax} = useFetchMataData(`/dropdown/dropdown-details/`,'Tax_Outgoing')
  const {value:ModeOfPayment ,getData:refModeOfPayment} = useFetchMataData(`/dropdown/dropdown-details/`,'Mode_of_Payment_Outgoing')
  const {value:Division ,getData:refDivision} = useFetchMataData(`/dropdown/dropdown-details/`,'Division_invoices')
  const {value:paymentTerms ,getData:refpaymentTerms} = useFetchMataData(`/dropdown/dropdown-details/`,'paymentTerms_invoices')
  const {value:status ,getData:refstatus} = useFetchMataData(`/dropdown/dropdown-details/`,'Status_Outgoing')

    const { data: user } = UseDropDown('/user/drop-down');
  
    const {value:category ,getData:refcategory} = useFetchMataData(`/dropdown/dropdown-details/`,'Category_Outgoing')
  const { data: contract } = UseDropDown(`/contract/drop-down`);
 
     
      const [image, setImage] = useState([]);
       const [fileRemoveList, setFileRemoveList] = useState([]);
          const location = useLocation();
      const data = location.state?.data;
      const from = location.state?.from;
      console.log(location.state,'state');
          const { Oncancel, editFormData,contextHolder,isLoading } = useEditFormData();
    
      const [createNew, setCreateNew] = useState({
         
          amount: data?.amount,
          tax: String(data?.tax),
          totalAmount: data?.totalAmount,
          modeOfPayment: data?.modeOfPayment,
          daysElapsed: data?.daysElapsed,
          comments: data?.comments,
          contractId: data?.contractId,
          division:data?.division,
          ref:data?.ref,
          paymentDueDate:data?.paymentDueDate,
         filesToRemove: [],
          status: data?.status,
            taxAmount:data?.taxAmount,
            costCode:data?.costCode,
            description:data?.description,
          category:data?.category,
          debitTo:data?.debitTo,
          receivedAmount:data?.receivedAmount,
          balanceAmount:data?.balanceAmount,
            receivedOn:data?.receivedOn,
          paymentTerms:data?.paymentTerms,

  
      
  
          
      })
      const [combinedItems, setCombinedItems] = useState([]);
      const [remove, setRemove] = useState([]);
  
      const [selectedFile, setSelectedFile] = useState(null);
       const [filePathList, setFilePathList] = useState([]);
       const [removefilePathList, setRemoveFilePathList] = useState([]);
       const [isModalOpen, setIsModalOpen] = useState(false);
       const [selectedImage, setSelectedImage] = useState(null);
       const [fileExtention, setFileExtention] = useState("");
       const toast = useToast();
     
       function handleImageChange(e) {
         const maxFileSize = 200000000; // 200 MB
         const files = Array.from(e.target.files);
         let fileArr = [];
         files.map((item) => {
           if (item.size < maxFileSize) {
             fileArr.push(item);
           } else {
             toast.open({
               type: "warning",
               message: `File Size to big`,
               description: `${item.name} is Removed and not Uploaded`,
               // placement: "bottomRight",
             });
           }
         });
         let tempArr = [];
         setSelectedFile(fileArr);
         files.map((item) => {
           if (item.size < maxFileSize) {
             let fileName = item?.name;
             console.log("fname", fileName);
             let fileExtention = fileName.split(".").reverse()[0];
             if (filetype?.includes(fileExtention)) {
               tempArr.push(fileName);
             } else {
               let x = URL.createObjectURL(item);
               tempArr.push(x);
             }
           }
         });
         console.log(tempArr, "temp");
         setImage(tempArr);
       }
     
       useEffect(() => {
         if (
           data?.attachments !== null &&
           data?.attachments !== "None" &&
           data?.attachments !== "[]"
         ) {
           console.log(data?.attachments, "ghjkllgd");
           setFilePathList(data?.attachments);
     
           setRemoveFilePathList(data?.attachments);
         }
       }, [data]);
     
       function UpdateAttachmentList(item) {
         let filterList = filePathList.filter((itemList) => itemList.file !== item);
         let removeFile = filePathList.find((itemList) => itemList.file === item);
         console.log("llll", filterList);
         setFileRemoveList([...fileRemoveList, removeFile.file]);
         setFilePathList(filterList);
       }
     
       function handleImageClick(img) {
         let Ext = img?.file_name.split(".").reverse()[0];
         setSelectedImage(img);
         setFileExtention(Ext);
         setIsModalOpen(true);
       } 
     
  
      const formik = useFormik({
          enableReinitialize: true,
          initialValues: createNew,
          validateOnChange: false,
          validateOnBlur: false,
          validationSchema: yup.object({
            // prId: yup.string().required('YPR is required!'),
            // coId: yup.string().required('Sales Order is required!'),
            amount: yup.string().required('amount is required!'),
            
      
          }),
          onSubmit: async (value, { resetForm }) => {
            // value.totalAmount=Number(value.totalAmount)
            if (items.length === 0 && data?.products?.length === 0) {
              setError("Product table is empty");
              return;
            }
            let formData = new FormData();
  
        const valueWithItems = {
          ...value,
          products: combinedItems,
          removedProducts: remove, 
          filesToRemove: fileRemoveList,
          
  
        };
        formData.append("json_data", JSON.stringify(valueWithItems));
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formData.append("attachments", file);
          });
        } else {
          formData.append("attachments", []);
        }
            // setLoading(true); 
              editFormData(`/invoices-outgoing/edit-invoice/${data.invoiceOutId}`, formData, resetForm, from);

              // setLoading(false)
          }
      })
  
    
      useEffect(() => {
        const amount = parseFloat(formik.values.amount || 0);
        const tax = parseFloat(formik.values.tax || 0);
        
        const taxAmount = ((amount)* tax/100);  
        
        formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
        formik.setFieldValue("totalAmount", (amount + taxAmount).toFixed(2));
      }, [formik.values.amount, formik.values.tax]);
  
      useEffect(() => {
            const totalAmount = parseFloat(formik.values.totalAmount || 0);
            const receivedAmount = parseFloat(formik.values.receivedAmount || 0);
            
            // const taxAmount = ((amount)* tax/100);  
            
            // formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
            formik.setFieldValue("balanceAmount", (totalAmount - receivedAmount).toFixed(2));
          }, [formik.values.totalAmount, formik.values.receivedAmount]);
      
          const [items, setItems] = useState([]);
      const [isEditQua, setIsEditQua] = useState(false);
      const [isEditReturnQua, setisEditReturnQua] = useState(false);
      const [dataa, setDatas] = useState(data);
    
      const [isEditUnit, setIsEditUnit] = useState(false);
      // console.log(items, "kk");
      // console.log(data, "pp");
      const [newItemData, setNewItemData] = useState({
        productName:"",
        purpose:"",
        quantity:"",
        returnedQty:"",
        unit:"",
        price:""
      });
      const [search, setSearch] = useState("");
     
        const [Item,setData] = useState([]);
      
      // const { data: Item, setData } = UseProductDropDownNew(
      //   `/items/new-drop-down`,
    
      //   search
      // );
    
      const { value: unit } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "Unit_item"
      );
  
         const [sortedProList,setSortedProList] =  useState([]);
         const [oldData, setOldData] = useState([])
        
       
         const [error, setError] = useState("");
           const [productError, setProductError] = useState("");
           const [unitError, setUnitError] = useState("");
           const [quantityError, setQuantityError] = useState("");
           const handleAdd = () => {
             let hasError = false;
         
             if (!formik.values.productName) {
               setProductError("Product is required");
               hasError = true;
             } else {
               setProductError("");
             }
         
             if (!formik.values.unit) {
               setUnitError("Unit is required");
               hasError = true;
             } else {
               setUnitError("");
             }
         
             if (!formik.values.quantity) {
               setQuantityError("Quantity is required");
               hasError = true;
             } else {
               setQuantityError("");
             }
         
             if (hasError) return;
         
             if (formik.values.productName && formik.values.quantity) {
               const selectedProduct = Item.find(
                 (i) => i.value === formik.values.productName
               );
               const newItem = {
                 productName: formik.values.productName,
                //  productName: sortedProList.find((i) => i.value === formik.values.productName),
                 quantity: formik.values.quantity,
                 price: formik.values.price,
                 unit: formik.values.unit,
               };
               setItems([...items, newItem]);
         
               setNewItemData({
                 productName: "",
                 unit: "",
                 quantity: "",
                 price:""
               });
               let updatedItems = Item.filter(
                 (it) => it.value !== formik.values.productName
               );
               setData(updatedItems);
               formik.values.productName = "";
               formik.values.quantity = "";
               formik.values.unit = "";
               formik.values.price = "";

         
               setError("");
             }
           };
         
           const handleQuantityChange = (e, index) => {
             const updatedQuantity = e.target.value;
         
             const updatedItems = items.map((item, idx) => {
               if (idx === index) {
                 return { ...item, quantity: updatedQuantity };
               }
               return item;
             });
         
             setItems(updatedItems);
           };
       
           const handleReturnQuantityChange = (e, index) => {
             let updatedQuantity = parseInt(e.target.value, 10) || "";
             updatedQuantity = Math.max("", updatedQuantity); 
           
             setItems((prevItems) =>
               prevItems.map((item, idx) =>
                 idx === index
                   ? {
                       ...item,
                       returnedQty: updatedQuantity > item.quantity ? item.quantity : updatedQuantity, 
                     }
                   : item
               )
             );
           };
  
           useEffect(()=>{
                     const filterdItem = Item.filter(
                       (drop) => !dataa?.products?.some((id) => id.productName === drop.value)
                     );
                     if(Item){
                       const union = Array.from(
                         new Map([...filterdItem, ...oldData].map((item) => [item.value, item])).values()
                       );
                       let data = union.sort((a, b) => a.label.localeCompare(b.label))
                       setSortedProList(data)
                     }
                     console.log("item",Item);
                     
                   },[Item])
                 
                   useEffect(() => {
                     if (formik.values.productName) {
                       const findValue = sortedProList.filter((v) => formik.values?.productName ==(v.value));
                       console.log("final",findValue);
                       
                       setOldData(findValue);
                     }
                     console.log("Testing",formik.values.productName);
                   },[formik.values.productName])
                 const [finalList, setFinalList] = useState(dataa?.products);
           
         
           const handleDeleteItem = (indexToDelete) => {
             const updatedItems = items.filter((_, index) => index !== indexToDelete);
             let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
             setItems(updatedItems);
             let tempDd = ddUpdatedItem.productName;
             setData([...Item, tempDd]);
             // localStorage.setItem("items", JSON.stringify(updatedItems));
           };
       
            const handleProductUnitChange = (value, index) => {
              console.log(value,"value");
  
               const updatedItems = items.map((item, idx) => {
                 if (idx === index) {
                   return { ...item, unit: value };
                 }
                 return item;
               });
               setItems(updatedItems);
               
             };
  
             const handleQuantityChangeAlredyExit = (e, index) => {
              const updatedItems = [...finalList];
              updatedItems[index].quantity = e.target.value;
              setFinalList(updatedItems);
              console.log("shsd", finalList);
            };
          
      
            const handleProductUnitChangeAlredyExit = (value, index) => {
              console.log(value,"value already ext");
              
              const updatedItems = [...finalList];
              updatedItems[index].unit = value;
              setFinalList(updatedItems);
              console.log("shsd", finalList);
            };
  
            useEffect(() => {
                      if (dataa?.products && items) {
                        const mergedArray = [...dataa.products, ...items];
                        setCombinedItems(mergedArray);
                      }
                    }, [dataa?.products, items]);
                    const handleDelete = (productName) => {
                      const updatedproducts = dataa?.products.filter(
                        (item) => item.productName !== productName
                      );
                      // const deletedItem = dataa?.products.find(item => item.productName === productName);
                      console.log(updatedproducts, "lll");
                  
                      setDatas((prevState) => ({
                        ...prevState,
                        products: updatedproducts,
                      }));
                      setRemove([...remove, productName]);
                  
                      // setremove(prevState => ({
                      //   ...prevState,
                      //   removedProducts: [...prevState.removedProducts, deletedItem]
                      // }));
                    };
  
    return (
      <div className="w-full h-full py-2 px-4 ">
        <div className="flex justify-between ">
          {/* <Breadcrumb
            items={[
              {
                name: "Invoice-Outgoing",
                link: `/project/sales/invoice_outgoing/${officeId}/${projectId}`,
              },
              {
                name: "Edit",
              },
            ]}
          /> */}

          
          <Breadcrumb
                            items={[
                              // { name: "Invoice" },
                              {
                                name: "Outgoing",
                                link:"/invoice/invoice-outgoing"
          
                               
                              },
                  
                              { name: "Edit" },
                            ]}
                          />
  
          <BackButton />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
            <div className=" w-full h-full py-4 px-3 flex justify-start content-start flex-wrap  overflow-y-auto">
            
             <NuInput
                                      label="Description"
                                      type="text"
                                      formik={formik}
                                      placeholder="Description"
                                      name="description"
                                      width="w-full md:w-1/2 lg:w-2/3"
                                    />
                                    <NuInput
                                    type="text"
                                    label="Cost Code "
                                    placeholder="Cost Code"
                                    formik={formik}
                                    name="costCode"
                                    width="w-full md:w-1/2 lg:w-1/3"
                                    // isRequired={true}
                                  />
           
           <FormikSelectTwo
                              
                              type="text" 
                              label="Contract"
                              placeholder="Contract"
                              Options={contract}
                              formik={formik}
                              name="contractId"
                              width="w-full md:w-1/2 lg:w-1/3"
                              isRequired={true}
                            />
                     <FormikSelectTwo
                type="text"
                label="Debit To"
                placeholder="Debit To"
                Options={user}
                formik={formik}
                name="debitTo"
                width="w-full md:w-1/2 lg:w-1/3"
                // isRequired={true}
                FixPosition={false}
                PortalTarget={false}
              />
              <NuInput
                type="number"
                label="Amount"
                placeholder="Amount"
                formik={formik}
                name="amount"
                width="w-full md:w-1/2 lg:w-1/3"
              />
  
              <FormikSelectTwo
                type="text"
                label="Tax (%)"
                placeholder="Choose"
                Options={Tax}
                formik={formik}
                name="tax"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={false}
                PortalTarget={false}
              />
   <NuInput
                type="number"
                label="Tax Amount"
                placeholder="Tax Amount"
                formik={formik}
                name="taxAmount"
                width="w-full md:w-1/2 lg:w-1/3"
                disabled={true}
              />
              <NuInput
                type="number"
                label="Total Amount"
                placeholder="Total Amount"
                formik={formik}
                name="totalAmount"
                width="w-full md:w-1/2 lg:w-1/3"
                disabled={true}
              />
  
              
              
                                      <NuInput
                                                    type="number"
                                                    label="Balance Amount"
                                                    placeholder="Balance Amount"
                                                    formik={formik}
                                                    name="balanceAmount"
                                                    width="w-full md:w-1/2 lg:w-1/3"
                                                    disabled={true}
                                                  />
  
              <NuDate
                label="Payment Due Date"
                placeholder="Payment Due Date"
                formik={formik}
                name="paymentDueDate"
                width="w-full md:w-1/2 lg:w-1/3"
              />
            
              <FormikSelectTwo
                label="Mode Of Payment"
                placeholder="Choose"
                formik={formik}
                Options={ModeOfPayment}
                name="modeOfPayment"
                width="w-full md:w-1/2 lg:w-1/3"
              />
  
  <FormikSelectTwo
                type="text"
                label="Category"
                placeholder="Choose"
                Options={category}
                formik={formik}
                name="category"
                width="w-full md:w-1/2 lg:w-1/3"
              />
  
  
              <FormikSelectTwo
                type="text"
                label="Division"
                placeholder="Choose"
                Options={Division}
                formik={formik}
                name="division"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <NuInput
                            type="number"
                            label="Days Elapsed"
                            placeholder="Days Elapsed"
                            formik={formik}
                            name="daysElapsed"
                            width="w-full md:w-1/2 lg:w-1/3"
                            />
               <FormikSelectTwo
              type="text"
              label="Payment Terms"
              placeholder="Payment Terms"
              Options={paymentTerms}
             formik={formik}
             name="paymentTerms"
             width="w-full md:w-1/2 lg:w-1/3"
            />
             <DropDownAddMetaData
                  label="Status"
                  placeholder="Choose"
                  Options={status}
                  formik={formik}
                  name="status"
                  width="w-full md:w-1/2 lg:w-1/3"
                  getFunc={refstatus}
                  displayProperty={"Status"}
                  propertyName={"Status_Outgoing"}
                />
             
              <NuTextArea
                label="Comments"
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <div className="w-full">
                  <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Attachement :
                  </p>
                </div>
                <div className="md:flex justify-between mt-5 px-3 w-full">
                  <div className="w-full flex gap-2 items-center flex-wrap">
                    {data?.attachments &&
                      filePathList?.map((imgs, idx) => {
                        console.log("img", imgs);
                        let Ext = imgs?.file_name.split(".").reverse()[0];
                        return (
                          <div
                            className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                            key={idx}
                            style={{
                              border: "1px solid gray",
                              borderColor:
                                "rgb(148 163 184 / var(--tw-bg-opacity))",
                            }}
                          >
                            <div
                              className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                              onClick={() => UpdateAttachmentList(imgs?.file)}
                            >
                              <CloseIcon color="white" height="8" width="8" />
                            </div>
                            <div
                              className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                              onClick={() => handleImageClick(imgs)}
                            >
                              <div className=" w-8 h-8">
                                {videotype.includes(Ext) ? <Video /> : null}
  
                                {Ext === ("docx" || "doc" || "txt") ? (
                                  <Doc />
                                ) : Ext === ("xlsx" || "xls") ? (
                                  <Xls />
                                ) : Ext === "txt" ? (
                                  <Txt />
                                ) : Ext === "pdf" ? (
                                  <Pdf />
                                ) : Ext === "PDF" ? (
                                  <Pdf />
                                ) : Ext === "pptx" ? (
                                  <>No file</>
                                ) : (
                                  <img src={imgs?.file} alt="#" width="120%" />
                                )}
                              </div>
                              <p className=" w-[50px] text-[11px] truncate">
                                {imgs?.file_name}
                              </p>
                            </div>
                          </div>
                        );
                      })}
  
                    <Attachement 
                      handleChange={handleImageChange}
                      preview={image || ""}
                      width="w-full md:w-1/2"
                      label="Attach"
                      multiple={true}
                    />
                  </div>
                </div>
             
              <div className="w-full mx-auto h-auto bg-white rounded-md overflow-hidden mt-4 ">
              <div className=" w-full h-full flex justify-start content-start flex-wrap  overflow-y-auto mb-4">
                <div className="w-full">
                  <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                    Products :
                  </p>
                </div>
                <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                  <NuInputWithError
                                  label="Product"
                                  type="text"
                                  formik={formik}
                                  placeholder="Product"
                                  name="productName"
                                  width="w-full md:w-1/2 lg:w-[67%]"
                                  ErrMessage={productError}
                                />
                                  <NuInputWithError
                                  label="Unit"
                                  type="text"
                                  formik={formik}
                                  placeholder="Unit"
                                  name="unit"
                                  width="w-full md:w-1/2 lg:w-1/4 "
                                  ErrMessage={unitError}
                                />
                              
                                <NuInputWithError
                                  label="Quantity"
                                  type="number"
                                  formik={formik}
                                  placeholder="Quantity"
                                  name="quantity"
                                  width="w-full md:w-1/2 lg:w-1/4 "
                                  ErrMessage={quantityError}
                                />
                                 <NuInputWithError
                                  label="Price"
                                  type="number"
                                  formik={formik}
                                  placeholder="Price"
                                  name="price"
                                  width="w-full md:w-1/2 lg:w-1/4 "
                                  ErrMessage={quantityError}
                                />
                 
  
                  <button
                    onClick={handleAdd}
                    type="button"
                    className=" p-1 mt-10 m-1 text-center h-8 cursor-pointer bg-textColor-main border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                  >
                    Add
                  </button>
                </div>
                <div className="w-full bg-white overflow-hidden mt-5">
                  {error && (
                    <p className="text-xs font-semibold text-red-500">{error}</p>
                  )}
                  <div className="w-full py-3  bg-textColor-main flex justify-between rounded-lg px-6">
                    <p className="w-[5%]  text-left  text-white text-xs font-medium">
                      S.No{" "}
                    </p>
  
                    <p className=" w-[40%] text-left text-white text-xs font-medium">
                      Product
                    </p>
                    <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                      Unit
                      {/* <span
                        className="pl-1 cursor-pointer"
                        onClick={() => {
                          setIsEditUnit((prv) => !prv);
                        }}
                      >
                        {isEditUnit === true && (
                          <EditIcon width={"14"} height={"14"} color="yellow" />
                        )}
                        {isEditUnit === false && (
                          <EditIcon width={"14"} height={"14"} />
                        )}
                      </span> */}
                    </p>
                    <p className=" w-[15%] text-center text-white text-xs font-medium flex justify-center">
                      Quantity
                      {/* <span
                        className="pl-1 cursor-pointer"
                        onClick={() => {
                          setIsEditQua((prv) => !prv);
                        }}
                      >
                        {isEditQua === true && (
                          <EditIcon width={"14"} height={"14"} color="yellow" />
                        )}
                        {isEditQua === false && (
                          <EditIcon width={"14"} height={"14"} />
                        )}
                      </span> */}
                    </p>
                    <p className=" w-[20%] text-center  text-white text-xs font-medium flex justify-center">
                    Price
                </p>
  
                    <p className=" w-[5%] text-right text-white text-xs font-medium">
                      Action
                    </p>
                  </div>
                  {items?.length > 0 || dataa?.products?.length > 0 ? (
                    <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                      {items.map((List, index) => {
                        return (
                          <div
                            key={index}
                            className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                          >
                            <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] ">
                              {index + 1}
                            </p>
                            <p className=" w-[40%] text-left  text-xs font-medium text-[#111537] ">
                              {List?.productName}
                            </p>
                            <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            {List?.unit}
                            
                              {/* <Select
                                value={
                                  unit.find(
                                    (item) => item?.value == List?.unit
                                  ) || List?.unit
                                }
                                options={isEditUnit ? unit : []}
                                className="w-full"
                                onChange={(value) =>
                                  handleProductUnitChange(value, index)
                                }
                                disabled={!isEditUnit}
                              /> */}
                            </p>
  
                            <p className=" w-[15%] text-center  text-xs font-medium text-[#111537] ">
                          {List?.quantity}
                          {/* <input
                                type="number"
                                className="w-11/12 mx-auto outline-none text-center"
                                value={List?.quantity || ""}
                                disabled={!isEditQua}
                                onChange={(e) => handleQuantityChange(e, index)}
                              /> */}
                            </p>
                            <p className=" w-[20%] text-center   text-xs font-medium text-[#111537] ">
                            {List?.price}</p>
                            <div className="w-[5%] text-right ">
                              <button
                                onClick={() => handleDeleteItem(index)}
                                type="button"
                                className="text-red-500 cursor-pointer  ml-4 border-none"
                              >
                                <DeleteIcon color="red" height={12} />
                              </button>
                            </div>
                          </div>
                        );
                      })}
                      {dataa?.products?.map((List, index) => {
                        return (
                          <div
                            key={index}
                            className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                          >
                            <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] ">
                              {index + 1 + items.length}
                            </p>
                            <p className=" w-[40%] text-left  text-xs  font-medium text-[#111537] ">
                              {List?.productName}
                            </p>
                            <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            {List?.unit}
                            {/* <Select
                                value={
                                  unit.find(
                                    (item) => item?.value == List?.unit
                                  ) || List?.unit
                                }
                                options={isEditUnit ? unit : []}
                                className="w-full"
                                onChange={(value) =>
                                  handleProductUnitChangeAlredyExit(value, index)
                                }
                                disabled={!isEditUnit}
                              /> */}
                            </p>
                            <p className=" w-[15%] text-center  text-xs font-medium text-[#111537] ">
                            {List?.quantity}
                            {/* <input
                                type="number"
                                className="w-11/12 mx-auto outline-none text-center"
                                value={List?.quantity}
                                disabled={!isEditQua}
                                onChange={(e) =>
                                  handleQuantityChangeAlredyExit(e, index)
                                }
                              /> */}
                            </p>
                            <p className=" w-[20%] text-center   text-xs font-medium text-[#111537] ">
                            {List?.price}</p>
  
                            <div className="w-[5%] text-right ">
                              <button
                                onClick={() => handleDelete(List?.productName)}
                                type="button"
                                className="text-red-500 cursor-pointer  ml-4 border-none"
                              >
                                <DeleteIcon color="red" height={12} />
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="w-full text-center text-[#93949f]">
                      No Items here
                    </div>
                  )}
  
                  {/* </div> */}
                </div>
               
              </div>
            </div> 
              {/* <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                <div className="w-full py-3 bg-[#048178] flex justify-between rounded-lg px-6">
                <p className="w-[5%]  text-left  text-white text-xs font-medium">S.N. </p>
  
                  <p className="w-[50%] text-left text-white text-xs font-medium">
                    Product
                  </p>
                  <p className="w-[10%] text-center text-white text-xs font-medium">
                    Unit
                  </p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">
                    {" "}
                    Quantity
                  </p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">Price</p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">Total</p>
  
                </div>
                {Colist?.length>0?
                <div className="h-[calc(100vh-300px)] overflow-y-scroll">
  
                {Colist.map((List, index) => (
                  <div
                    key={index}
                    className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-50"
                  >
                     <p className="w-[5%]  text-left  text-[#606279] text-xs font-light py-1">
                                      {index + 1}
                                  </p>
                    <p className="w-[50%] text-left text-[#606279] text-xs font-light">
                      {List?.product_name}
                    </p>
                    <p className="w-[10%] text-center text-[#606279] text-xs font-light">
                      {List?.unit}
                    </p>
                    <p className="w-[15%] text-center text-[#606279] text-xs font-light">
                      {List?.quantity}
                    </p>
                    <p className="w-[15%] text-center text-[#606279] text-xs font-light">{List?.price}</p>
                    <p className=" w-[15%] text-center text-[#606279] text-xs font-light">
                    {(List.price * List.quantity ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                    
                    </p>
                  </div>
                ))}
              </div>:<div className="w-full text-center text-[#93949f]">No Items here</div>}
  
              </div> */}
              <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
                <div className="md:flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading}/>
                </div>
              </div>
            </div>
          </div>
        </form>
        <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <img src={selectedImage?.file} alt={selectedImage?.file} />
        </Modal>
      </div>
    );
}

export default EditInvoiceOutgoing
